/**
 * Meta in-app webview detection.
 *
 * Google blocks OAuth inside embedded webviews ("disallowed_useragent"), so
 * "Sign in/up with Google" can never work inside the Instagram, Facebook, or
 * Messenger in-app browsers — the majority of our paid traffic. Pages use this
 * to hide the Google option there instead of showing a button that fails
 * silently (Clarity recordings showed users clicking it repeatedly, then
 * abandoning).
 */
export const isMetaWebview = () => {
  const ua = navigator.userAgent || '';
  // Instagram sets "Instagram"; Facebook/Messenger set FBAN/FBAV/FB_IAB/FBIOS.
  return /\bInstagram\b|FBAN|FBAV|FB_IAB|FBIOS/i.test(ua);
};

export default isMetaWebview;
